import {Component, ElementRef, Inject, Injector, OnDestroy, OnInit} from '@angular/core';
import {
  MsalService,
   MSAL_INSTANCE
} from '@azure/msal-angular';
import {ActivatedRoute} from "@angular/router";
import { IPublicClientApplication} from "@azure/msal-browser";



@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  submitting = false;
  public emailName = '';
  public isInited: boolean;

  constructor(
    injector: Injector,
    public msalService: MsalService,
    public element: ElementRef,
    @Inject(MSAL_INSTANCE) public instance: IPublicClientApplication,
    private state: ActivatedRoute
  ) {
    this.isInited = false;
  }

  login() {
    this.isInited = false;
    this.submitting = true;
    this.instance.loginRedirect()
  }

  ngOnInit() {


    this.msalService.handleRedirectObservable().subscribe({
      next: (result: any) => {
        if (result) {
          this.msalService.instance.setActiveAccount(result.account);
          location.href = this.state.snapshot.queryParams.returnUrl;
        }
      },
      error: (error) => console.log(error)
    });
  }

  ngOnDestroy() {
    this.isInited = false;
  }
}
